import { useState, useEffect, useCallback } from "react";
import { useWidgetStore } from "@/stores/widget-store";
import { dismissBanner } from "@/services/widget";

export const useBannerVisibility = (bannerId: string) => {
    const banners = useWidgetStore((state) => state.config.banners || {});
    const fetchConfig = useWidgetStore((state) => state.fetchConfig);

    const checkVisibility = useCallback(() => {
        const bannerData = banners[bannerId];

        if (!bannerData) return true;
        if (bannerData.status === false) return false;
        // Respect a future `until` timestamp — banner is scheduled but not yet due
        if (bannerData.until && Date.now() < bannerData.until) return false;
        return bannerData.status;
    }, [banners, bannerId]);

    const [isVisible, setIsVisible] = useState(checkVisibility());

    useEffect(() => {
        setIsVisible(checkVisibility());
    }, [checkVisibility]);

    const hide = async () => {
        setIsVisible(false);
        try {
            await dismissBanner(bannerId);
            await fetchConfig();
        } catch (error) {
            setIsVisible(true);
            console.error("Failed to dismiss banner:", error);
        }
    };

    return {
        isVisible,
        hide,
    };
};
